import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
// Lazy-load below-the-fold sections so the landing paint ships less JS
const MiniSlider = lazy(() => import('../components/MiniSlider').then(m => ({
  default: m.MiniSlider
})));
const About = lazy(() => import('../components/About').then(m => ({
  default: m.About
})));
const Founder = lazy(() => import('../components/Founder').then(m => ({
  default: m.Founder
})));
const Impact = lazy(() => import('../components/Impact').then(m => ({
  default: m.Impact
})));
const Gallery = lazy(() => import('../components/Gallery').then(m => ({
  default: m.Gallery
})));
const Programs = lazy(() => import('../components/Programs').then(m => ({
  default: m.Programs
})));
const Donate = lazy(() => import('../components/Donate').then(m => ({
  default: m.Donate
})));
const Contact = lazy(() => import('../components/Contact').then(m => ({
  default: m.Contact
})));
function SectionFallback() {
  return <div className="py-24 flex items-center justify-center" data-id="element-456">
      <div className="w-6 h-6 border-2 border-gold/30 border-t-gold rounded-full animate-spin" data-id="element-457" />
    </div>;
}
export function Home() {
  return <main className="flex-grow" data-id="element-458">
      <Hero data-id="element-459" />
      <Marquee data-id="element-460" />
      <Suspense fallback={<SectionFallback data-id="element-462" />} data-id="element-461">
        <MiniSlider data-id="element-463" />
        <About data-id="element-464" />
        <Founder data-id="element-465" />
        <Impact data-id="element-466" />
        <Gallery data-id="element-467" />
        <Programs data-id="element-468" />
        <Donate data-id="element-469" />
        <Contact data-id="element-470" />
      </Suspense>
    </main>;
}